import axios from 'axios';

const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
const url = document.querySelector('meta[name="geoUrlPath"]').getAttribute('content');

window.axios = axios.create({
  baseURL: url + '/',
  timeout: 60000,
  headers: {
    'X-Application': 'desktop',
    'X-CSRF-TOKEN': token,
    'Content-Type': 'application/json',
  },
  withCredentials: true
});